<script lang="ts">
    import {getInjector} from 'src/core';
    import type {Rec} from 'src/typings';
    import type {MediaViewerInlineData} from './lib/mv-types';
    import {onMount} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {MediaViewerService} from './services/media-viewer.service';
    import MediaViewer from './MediaViewer.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';

    export let record: Rec;
    export let editMode = null;

    const service = getInjector().getByClass(MediaViewerService);
    let data: MediaViewerInlineData;

    onMount(async () => {
        data = await service.getInlineMediaViewerData(record);
        editMode ??= data.editMode;
    });
</script>

{#if exists(data)}
    <div class="inline-media-viewer-wrapper">
        <MediaViewer rootDirectoryNode={data.parentDirectory}
                     editMode={editMode}
                     viewedFile={null}
                     backToCatalogUrl={null}
                     isInInlineMode/>
    </div>
{:else}
    <div class="inline-media-viewer-wrapper">
        <KpLoadingBlock fillAvailableSpace/>
    </div>
{/if}

<style lang="less">
    @import (reference) "styles/portaro-erp.less";
    @import (reference) "src/features/media-viewer/media-viewer.themes.less";

    .inline-media-viewer-wrapper {
        .flex-grow();
        position: relative;
    }

    :global {
        .inline-media-viewer-wrapper > #media-viewer {
            .portaro-themed-variables-redefinition();

            .mv-viewed-content {
                border-top: none !important;
                border-top-left-radius: 0 !important;
            }
        }
    }
</style>